/** English: the complete dictionary. Urdu and Arabic translate every key here (see ur.ts, ar.ts).
 *  Screens not covered by these keys are written in English directly and listed in docs/WEB.md. */
export const en = {
  // navigation
  'nav.main': 'Main menu',
  'nav.home': 'Home',
  'nav.home.overview': 'Overview',
  'nav.home.today': 'Today on site',
  'nav.home.weekly': 'Weekly update',
  'nav.projects': 'Projects',
  'nav.projects.all': 'All projects',
  'nav.projects.stages': 'Stages and progress',
  'nav.projects.timeline': 'Timeline',
  'nav.projects.files': 'Drawings and files',
  'nav.projects.diary': 'Site diary',
  'nav.projects.photos': 'Photos',
  'nav.office': 'Site office',
  'nav.office.attendance': 'Attendance',
  'nav.office.wages': 'Wage sheet',
  'nav.office.workers': 'Workers and teams',
  'nav.office.todos': 'To-dos',
  'nav.office.visitors': 'Visitors',
  'nav.stores': 'Stores',
  'nav.stores.stock': 'Stock on site',
  'nav.stores.receive': 'Receive',
  'nav.stores.issue': 'Issue to work',
  'nav.stores.transfers': 'Transfers',
  'nav.stores.water': 'Water tankers',
  'nav.stores.debris': 'Debris trucks',
  'nav.buy': 'Purchasing',
  'nav.buy.requests': 'Requests',
  'nav.buy.quotations': 'Quotations',
  'nav.buy.orders': 'Purchase orders',
  'nav.buy.suppliers': 'Suppliers',
  'nav.money': 'Money',
  'nav.money.budget': 'Budget and estimate',
  'nav.money.changes': 'Change orders',
  'nav.money.invoices': 'Client invoices',
  'nav.money.bills': 'Bills',
  'nav.money.petty': 'Petty cash',
  'nav.money.payments': 'Payments',
  'nav.money.tax': 'Tax',
  'nav.clients': 'Clients',
  'nav.clients.links': 'Client links',
  'nav.clients.selections': 'Selections',
  'nav.clients.enquiries': 'Enquiries',
  'nav.reports': 'Reports',
  'nav.reports.progress': 'Progress',
  'nav.reports.cost': 'Cost against budget',
  'nav.reports.stock': 'Stock and water',
  'nav.reports.attendance': 'Attendance and wages',
  'nav.reports.export': 'Export',
  'nav.settings': 'Settings',
  'nav.settings.company': 'Company and sites',
  'nav.settings.people': 'People and roles',
  'nav.settings.templates': 'Templates and rates',
  'nav.settings.plan': 'Plan and billing',
  'nav.settings.export': 'Export my data',
  'nav.approvals': 'Approvals',
  'nav.later': 'Later',
  'nav.by': 'Buildiary by SMH Global Services',
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',
  'nav.collapse': 'Collapse menu',
  'nav.expand': 'Expand menu',
  'nav.breadcrumb': 'Breadcrumb',
  'nav.skip': 'Skip to content',
  'nav.home.link': 'Buildiary home',

  // top bar
  'top.search': 'Search or jump to…',
  'top.project': 'Project',
  'top.projects': 'Projects',
  'top.allProjects': 'All {n} projects',
  'top.siteDate': 'Site date',
  'top.approvals': 'Approvals, {n} waiting',
  'top.notifications': 'Notifications, {n} new',
  'top.notesTitle': 'Notifications',
  'top.noNotes': 'Nothing new today.',
  'top.language': 'Language',
  'top.account': 'Account',
  'top.signOut': 'Sign out',
  'top.changePin': 'Change my PIN',
  'top.gateMode': 'Gate mode (tablet)',
  'top.feedback': 'Send feedback',
  'top.switchProject': 'Switch project',
  'top.demo': 'Demo workspace',

  // search palette
  'pal.title': 'Search or jump to',
  'pal.placeholder': 'Type a page, worker, item, supplier or number…',
  'pal.goTo': 'Go to',
  'pal.found': 'Found',
  'pal.none': 'Nothing found.',
  'pal.searching': 'Searching…',
  'pal.navigate': 'to move',
  'pal.select': 'to open',

  // sign-in
  'si.kicker': 'Demo workspace',
  'si.kickerLive': 'Construction site management',
  'si.headline': 'Your construction site, on your phone.',
  'si.promise': 'A photo, a name and a time on every entry, so the owner and the builder see the same facts.',
  'si.f1': 'Attendance by site card or PIN at the gate',
  'si.f2': 'Stores, water tankers and debris trucks, each with a photo',
  'si.f3': 'A weekly update for the owner in English, Urdu or Arabic',
  'si.endorse': 'A product of SMH Global',
  'si.title': 'Sign in',
  'si.lead': 'Use your work email, or pick a person below to look around the demo.',
  'si.leadLive': 'Use your work email or phone and your password.',
  'si.email': 'Email or phone',
  'si.password': 'Password',
  'si.passwordDemo': 'Not needed in the demo',
  'si.continueAs': 'Continue as {name}',
  'si.signIn': 'Sign in',
  'si.or': 'or try the demo as',
  'si.demoNote': 'The demo uses sample sites and keeps everything in this browser. To start your own workspace, go to',
  'si.staff': 'Site staff: sign in with card or PIN',
  'si.staffTitle': 'Sign in with your site card or PIN',
  'si.staffLead': 'Type the number on your site card, or your phone number, then your PIN.',
  'si.workspace': 'Workspace',
  'si.card': 'Card number or phone',
  'si.pin': 'PIN',
  'si.emailRequired': 'Type your email or phone.',
  'si.passwordRequired': 'Type your password.',
  'si.pinRequired': 'Type your 4 to 6 digit PIN.',
  'si.cardRequired': 'Type your card number or phone.',
  'si.failed': 'That did not work. Check the details and try again.',
  'si.signingIn': 'Signing in…',
  'persona.owner': 'Home, with the weekly update',
  'persona.ownersup': 'Approvals and site visits',
  'persona.supervisor': 'Today: attendance and diary',
  'persona.store': 'Stores: receive and issue',
  'persona.accounts': 'Money: bills and payments',
  'persona.partner': 'Their client projects only',
  'role.partnerShort': 'Builder (partner)',

  // common actions
  'c.save': 'Save',
  'c.cancel': 'Cancel',
  'c.close': 'Close',
  'c.add': 'Add',
  'c.edit': 'Edit',
  'c.delete': 'Delete',
  'c.back': 'Back',
  'c.next': 'Next',
  'c.done': 'Done',
  'c.approve': 'Approve',
  'c.decline': 'Decline',
  'c.send': 'Send',
  'c.retry': 'Try again',
  'c.loading': 'Loading…',
  'c.error': 'Something went wrong.',
  'c.empty': 'Nothing here yet.',
  'c.search': 'Search',
  'c.all': 'All',
  'c.export': 'Export',
  'c.download': 'Download',
  'c.copy': 'Copy link',
  'c.copied': 'Copied',
  'c.share': 'Share',
  'c.whatsapp': 'Send by WhatsApp',
  'c.open': 'Open',
  'c.saved': 'Saved',
  'c.photo': 'Photo',
  'c.addPhoto': 'Add photo',
  'c.today': 'Today',
  'c.later': 'Later',
  'c.laterNote': 'Planned for a later release. Nothing to do here yet.',
  'c.required': 'Required',
  'c.offline': 'Offline: saved on this device, sends when back online',
  'c.print': 'Print',
  'c.undo': 'Undo',
  'c.optional': 'optional',
  'c.uploading': 'Uploading…',
  'c.noAccess': 'You do not have access to this page.',
  'c.notFound': 'Page not found.',
  'c.goHome': 'Go to the start page',

  // phone: tab bar and the + sheet
  'm.today': 'Today',
  'm.scan': 'Scan',
  'm.add': 'Add',
  'm.inbox': 'Inbox',
  'm.more': 'More',
  'm.morning': 'Good morning, {name}',
  'm.afternoon': 'Good afternoon, {name}',
  'm.evening': 'Good evening, {name}',
  'm.allSent': 'All sent',
  'm.onSite': 'On site',
  'm.notYet': '{n} not in yet',
  'm.waterTank': 'Water tank',
  'm.tankRead': 'Read at {time}',
  'm.noTank': 'No reading yet',
  'm.deliveries': 'Deliveries',
  'm.deliveriesSub': '{n} received today',
  'm.lowStock': 'Low stock',
  'm.lowSub': '{item} {qty} left',
  'm.doNext': 'Do next',
  'm.scanCard': 'Scan card',
  'm.receive': 'Receive',
  'm.voiceNote': 'Voice note',
  'm.nothingNext': 'Nothing waiting. Well done.',
  'm.markNotIn': 'Mark the {n} who are not in',
  'm.markNotInSub': 'Late, absent or on leave · before 09:00',
  'm.due': 'Due {date}',
  'm.addTitle': 'Add to the site record',
  'add.receive': 'Receive delivery',
  'add.issue': 'Issue to work',
  'add.water': 'Water tanker',
  'add.debris': 'Debris truck',
  'add.diary': 'Diary note, by voice',
  'add.photo': 'Progress photo',
  'add.bill': 'Bill or receipt',
  'add.petty': 'Petty cash',

  // phone: scan
  'scan.title': 'Scan site card',
  'scan.gate': '{project} · gate',
  'scan.in': 'In',
  'scan.out': 'Out',
  'scan.comingIn': 'Coming in',
  'scan.goingOut': 'Going out',
  'scan.hold': 'Hold the card inside the frame',
  'scan.holdOut': 'Going out: hold the site card inside the frame',
  'scan.faceNote': 'The camera also takes a face photo for the record',
  'scan.usePin': 'Use PIN',
  'scan.noCard': 'No card? Use PIN',
  'scan.torch': 'Torch',
  'scan.typeCode': 'Type card number',
  'scan.onSite': 'On site by GPS',
  'scan.offSite': 'GPS not on site',
  'scan.noGps': 'No GPS',
  'scan.photoSaved': 'Photo saved',
  'scan.noPhoto': 'No photo',
  'scan.day': 'Day {n} this month',
  'scan.next': 'Next card',
  'scan.noCamera': 'The camera is not available. Type the card number or use a PIN.',
  'scan.cardNo': 'Card number',
  'scan.worker': 'Worker',
  'scan.pinTitle': 'Sign in or out with a PIN',
  'scan.record': 'Record',
  'scan.undone': 'Removed. Scan again when ready.',
  'scan.close': 'Close',
  'scan.waiting': 'Waiting for a card',

  // phone: receive delivery
  'recv.title': 'Receive delivery',
  'recv.step1': 'Step 1 of 2 · delivery note',
  'recv.step2': 'Step 2 of 2 · check what arrived',
  'recv.notePhoto': 'Delivery note photo',
  'recv.takeNote': 'Take a photo of the delivery note',
  'recv.supplier': 'Supplier',
  'recv.noteNo': 'Delivery note number',
  'recv.order': 'Purchase order',
  'recv.noOrder': 'No order: delivered without one',
  'recv.matched': 'Matched to order {order}',
  'recv.what': 'What arrived',
  'recv.ordered': 'ordered {q}',
  'recv.short': '{n} {unit} short: the supplier is told, the bill will be checked',
  'recv.goods': 'Photo of the goods',
  'recv.draft': 'Save as draft',
  'recv.addStock': 'Add to stock',
  'recv.addLine': 'Add an item',
  'recv.item': 'Item',
  'recv.qty': 'Quantity received',
  'recv.less': 'Less',
  'recv.more': 'More',
  'recv.noteRequired': 'A photo of the delivery note is required by your workspace rules.',
  'recv.goodsRequired': 'A photo of the goods is required by your workspace rules.',
  'recv.noLines': 'Add at least one item with a quantity.',
  'recv.done': 'Added to stock: {n} lines.',
  'recv.draftSaved': 'Draft saved on this device.',
  'recv.by': '{name} · {time}',

  // phone: diary
  'lang.en': 'English',
  'lang.ur': 'Urdu',
  'lang.ar': 'Arabic',
  'diary.title': 'Site diary',
  'diary.voice': 'Voice note · {name}',
  'diary.note': 'Note · {name}',
  'diary.photos': '{n} progress photos · {name}',
  'diary.ai': 'Written by AI from {lang} · check it',
  'diary.hold': 'Hold to talk',
  'diary.recording': 'Recording… release to send',
  'diary.tapMode': 'Tap to start, tap again to send',
  'diary.type': 'Or type a note…',
  'diary.send': 'Send note',
  'diary.play': 'Play voice note',
  'diary.pause': 'Pause',
  'diary.mic': 'The microphone is blocked. Allow it in the browser, or type the note.',
  'diary.saved': 'Added to the diary.',
  'diary.empty': 'No diary entries on this day yet.',
  'diary.uploading': 'Sending the voice note…',
  'diary.short': 'Too short: hold the button while you talk.',

  // owner (phone) and client link
  'owner.house': 'Your house',
  'owner.week': '{week}',
  'owner.handover': 'On plan for handover {date}',
  'owner.from': 'This week from {name}',
  'owner.spent': 'Spent this week',
  'owner.under': '{amt} under plan',
  'owner.over': '{amt} over plan',
  'owner.nextPay': 'Next payment',
  'owner.stageDue': 'Stage {n} · due {date}',
  'owner.nothingDue': 'Nothing due',
  'owner.needsYes': 'Needs your yes',
  'owner.ask': 'Ask {name}',
  'owner.more': '{n} more: {title}, {amt}',
  'owner.days': '{n} more days',
  'owner.noDays': 'No change to the finish date',
  'owner.built': '{n} percent built',
  'owner.photos': 'Photos',
  'owner.invoices': 'Invoices and stage payments',
  'owner.changes': 'Change orders',
  'owner.paid': 'Paid',
  'owner.due': 'Due {date}',
  'owner.notYet': 'Not yet',
  'owner.approved': 'Approved',
  'owner.declined': 'Declined',
  'owner.waiting': 'Waiting for you',
  'owner.note': 'A note for the builder',
  'owner.confirmApprove': 'Approve {number} for {amt}?',
  'owner.confirmDecline': 'Decline {number}?',
  'owner.thanks': 'Thank you. Your answer has been sent to the builder.',
  'owner.noUpdate': 'The weekly update is not ready yet.',
  'owner.allDone': 'Nothing waits for your answer.',
  'client.shared': 'Shared by {workspace} with Buildiary',
  'client.private': 'No sign-in needed. This link is only for you; please do not forward it.',
  'client.bad': 'This link has expired or is not right. Ask your builder for a new one.',
  'client.stage': 'Now: {stage}',
  'client.progress': 'Progress',
  'client.total': 'Total',
  'client.amount': 'Amount',
  'client.lines': 'What changes',
  'supplier.title': 'Statement for {name}',
  'supplier.orders': 'Orders',
  'supplier.bills': 'Bills',
  'supplier.payments': 'Payments',
  'supplier.balance': 'Balance owed to you',
  'supplier.from': 'From {workspace}',

  // weekly update (home card, clients)
  'wk.title': 'Weekly update for the owner',
  'wk.draftedAi': 'drafted by AI · you check before it goes',
  'wk.draftedTemplate': 'built from the template · you check before it goes',
  'wk.sends': 'Sends {when} by WhatsApp and email',
  'wk.checkSend': 'Check and send',
  'wk.sent': 'Sent {when}',
  'owner.sentOn': 'Sent {when}',
  'si.at': 'Sign in to {name}',
  'si.notYou': 'Not your workspace?',
  'si.find': 'Find my workspace',
  'si.forgot': 'Forgot your password? Ask the owner of the workspace to send you a new link.',
  'si.start': 'Start a free trial',
  'nows.title': 'There is no workspace at this address',
  'nows.text': 'Check the name in the address, for example alnoor.buildiary.app. If you have forgotten it, we can email it to you.',
  'nows.site': 'About Buildiary',
  'my.title': 'Your construction site, on your phone.',
  'my.lead': 'Start a free trial, or find the address of your workspace.',
  'my.go': 'Go to my workspace',
  'my.goHint': 'Type the name of your workspace',
  'my.console': 'SMH Global team: console',
  'find.title': 'Find my workspace',
  'find.lead': 'Type the email you sign in with. We will email you the address of each workspace you belong to.',
  'find.email': 'Your email',
  'find.send': 'Email me the links',
  'st.title': 'Start your free trial',
  'st.lead': '{days} days free. No card, no automatic charges: you pay by bank transfer only when you decide to continue.',
  'st.what': 'What are you building?',
  'st.owner': 'My own home',
  'st.builder': 'Projects for clients',
  'st.perMonth': '{price} a month',
  'st.perYear': 'or {price} a year',
  'st.limits': '{projects} projects · {users} people',
  'st.data': 'How do you want to start?',
  'st.empty': 'Empty, with my own project',
  'st.sample': 'With sample data for my country',
  'st.name': 'Your name',
  'st.email': 'Email',
  'st.country': 'Country',
  'st.phone': 'Mobile (WhatsApp)',
  'st.company': 'Workspace name',
  'st.companyHint': 'Your company, or the house you are building',
  'st.address': 'Address',
  'st.free': 'Free',
  'st.agree': 'I accept the terms and the privacy policy',
  'st.terms': 'terms',
  'st.go': 'Start my free trial',
  'st.checkTitle': 'Check your email',
  'st.checkLead': 'We sent a 6-digit code to {email}. Type it here, or open the link in the email.',
  'st.mailOff': 'Our team will send you the code shortly (by email or WhatsApp).',
  'st.code': 'Code',
  'st.confirm': 'Confirm and open my workspace',
  'st.resend': 'Send a new code',
  'st.resent': 'A new code is on its way.',
  'st.opening': 'Your workspace is ready. Opening it…',
  'st.ready': 'Your workspace is ready',
  'st.openIt': 'Open {host}',
  'st.closed': 'New sign-ups are closed for now. Please contact us.',
  'st.have': 'Already have a workspace?',
  'plan.trialLeft': 'Free trial: {n} days left.',
  'plan.trialLast': 'Free trial: today is the last day.',
  'plan.paidLeft': 'Your plan ends in {n} days.',
  'plan.ended': 'Your free trial has ended. Everything is safe and can be read; nothing new can be added until the plan is paid.',
  'plan.endedPaid': 'Your plan has ended. Everything is safe and can be read; nothing new can be added until it is renewed.',
  'plan.pay': 'Plan and billing',
  'plan.askOwner': 'Ask the owner to renew it.',
  'top.changeWorkspace': 'Change workspace',
  'scan.native': 'Scan the card',
} as const;

export type Key = keyof typeof en;
